import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection,AngularFirestoreDocument } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { Observable,Subscription } from 'rxjs';
import { Events} from 'ionic-angular';
import { first } from 'rxjs/operators';
import { User } from  '../../models/user';
import { Storage } from '@ionic/storage';
import { map } from 'rxjs/operators';
import { DataProvider } from '../data/data';
import { HttpClient } from '@angular/common/http';
import { firestore } from 'firebase';
import * as moment from 'moment';
/*
  Generated class for the NotificationsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class NotificationsProvider {

  constructor(private afs: AngularFirestore,private storage: Storage, public events:Events,private http: HttpClient, private dataProvider:DataProvider,private fbStorage: AngularFireStorage) {
    console.log('Hello NotificationsProvider Provider');
  }

  intializeSubscriptions(){
  	this.events.subscribe('notifications:get', () => {
       this.getNotifications();
    });
  }

  removeSubscriptions(){
  	 this.events.unsubscribe('notifications:get');

   }

  async getNotifications(){
  	if(this.dataProvider.user && this.dataProvider.user.uid){
  		   const notifications = await this.afs.collection('users').doc(this.dataProvider.user.uid).collection('notifications',ref => ref.orderBy('postedOn','desc')).snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as any;
                    const id = a.payload.doc.id;
                    if(data.postedOn){
                      data['postedOn'] = data.postedOn.toDate();
                    }
                    return { id, ...data };
	    }))).pipe(first()).toPromise();
	    this.events.publish('notifications:list',notifications);
  	}
  }


}



// WEBPACK FOOTER //
// ./src/providers/notifications/notifications.ts